import { IUserTokenDataDto } from "../../../interfaces/user/IUserTokenDataDto";
import { sessionKeys } from "./sessionKeys";

export const setSessionStorage = (key: string, item: string) => {
    sessionStorage.setItem(key, item);
};

export const getSessionStorage = (key: string) => {
    return sessionStorage.getItem(key) as string;
};

export const getBaseURLWithAuth = () => {
    const sessionStorage = getSessionStorage(sessionKeys.user);

    if (sessionStorage) {
        const user: IUserTokenDataDto = JSON.parse(sessionStorage);
        return `/user/${user?.UserId}/`
    }
};

export function updateSessionStoreWithUserInformation(token: string, user: IUserTokenDataDto) {
    setSessionStorage(sessionKeys.token, token);
    setSessionStorage(sessionKeys.user, JSON.stringify(user))
};